export default "__VITE_ASSET__ce253274__"